import { render, staticRenderFns } from "./Sourcing.vue?vue&type=template&id=148813da&scoped=true"
import script from "./Sourcing.vue?vue&type=script&lang=js"
export * from "./Sourcing.vue?vue&type=script&lang=js"
import style0 from "./Sourcing.vue?vue&type=style&index=0&id=148813da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148813da",
  null
  
)

export default component.exports